const List = () => import('./main.vue');

export default [
  {
    name: 'relatorio/qtde-faixa-etaria-parentesco',
    path: '/relatorio/qtde-faixa-etaria-parentesco',
    components: { default: List },
    meta: {
      requiresAuth: true,
      breadcrum: 'Qtde. Beneficiários Faixa Etária e Parentesco',
      icon: 'file-excel',
      can: 'rep293',
      on: 'report',
      client: 'cnen',
    },
  },
];
